class FindYourSolution extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('[data-tab-trigger]');
        this.panels = this.querySelectorAll('[data-tab-panel]');
        this.viewAllLinks = this.querySelectorAll('[data-view-all-link]');
        this.addButtons = this.querySelectorAll('[data-add-to-cart]');
    }

    connectedCallback() {
        if (this.tabs.length) {
            this.tabs.forEach((tab) => {
                tab.addEventListener('click', () => this.handleTabClick(tab));
            });
        }

        if (this.addButtons.length) {
            this.addButtons.forEach((button) => {
                button.addEventListener('click', (event) => this.handleAddToCart(event, button));
            });
        }
    }

    handleTabClick(tab) {
        const targetId = tab.dataset.tabTarget;
        const collectionUrl = tab.dataset.collectionUrl || '#';

        this.tabs.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
        });

        this.panels.forEach((panel) => {
            panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = this.querySelector(`#${targetId}`);
        if (activePanel) {
            activePanel.classList.add('is-active');
        }

        if (this.viewAllLinks.length) {
            this.viewAllLinks.forEach((link) => {
                link.setAttribute('href', collectionUrl);
            });
        }
    }

    async handleAddToCart(event, button) {
        event.preventDefault();
        event.stopPropagation();

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.classList.add('loading');

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: Number(variantId),
                            quantity: 1
                        }
                    ]
                })
            });

            if (!response.ok) {
                throw new Error('Cart add failed');
            }

            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true
                })
            );

            button.classList.remove('loading');
            button.classList.add('is-added');

            const originalText = button.innerHTML;
            button.innerHTML = '<span>ADDED</span>';

            setTimeout(() => {
                button.innerHTML = originalText;
                button.classList.remove('is-added');
            }, 1200);
        } catch (error) {
            console.error(error);
            button.classList.remove('loading');
        }
    }
}

if (!customElements.get('find-your-solution')) {
    customElements.define('find-your-solution', FindYourSolution);
}

document.querySelectorAll('.find-solution').forEach((section) => {
    if (!section.closest('find-your-solution-wrapper')) {
        const wrapper = document.createElement('find-your-solution');
        section.parentNode.insertBefore(wrapper, section);
        wrapper.appendChild(section);
    }
});